(function (app) {
    app.constant("configuration", {
        "APIUrl": "google.com",
        "POSTUrl": "https://vp72vr1brd.execute-api.us-east-1.amazonaws.com/prod/contactus",
        "APIKey": "gVie6ThIJk8H9P1SziwlnGq38w5uU7i3N8oyPtqf"
    });
})(window.app);